/**
 * SAP CONFIDENTIAL 
 *
 * This software is confidential proprietary software licensed by SAP SE 
 * and is not to be used, duplicated or disclosed to anyone without the 
 * prior written permission of SAP. 
 *
 * (C) 2020 Copyright SAP SE.
 */
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Injectable()
export class PlanService {
	private url: string = environment.host + '/plan';
	private updateDefaultPlans: string = environment.host + '/region/defaultplans';
	private tabDetails: any;
	private baseGlobalCompUrl: string = environment.host + '/compensation';

	constructor(private http: HttpClient) {}

	public getAllPlanDefinitions() {
		return this.http.get(this.url.toString()).toPromise();
	}

	public getRegionBasedPlans(regionCode: any) {
		const url = environment.host + '/region/' + regionCode + '/plan';
		return this.http.get(url.toString()).toPromise();
	}

	public getPlanDetails(planId: any) {
		return this.http.get(this.url.toString() + '\\' + planId).toPromise();
	}

	public setDefaultPlans(data: any) {
		return this.http.post(this.updateDefaultPlans.toString(), data).toPromise();
	}

	public getPlanMetadata() {
		return this.http.get(this.url.toString() + '/metadata').toPromise();
	}

	public getPlanMetadataTabType() {
		return this.http.get(this.url.toString() + '/metadata?tabType=' + 'PM/plan/metadata').toPromise();
	}

	public getPlanSummary(planId: any) {
		return this.http.get(this.url.toString() + '\\' + planId + '/summary').toPromise();
	}

	public getTabDetails() {
		return this.tabDetails;
	}

	public setTabDetails(tabDetails: any) {
		this.tabDetails = tabDetails;
	}

	public getCurrentTabIndex(tab: any) {
		let tabIndex;
		this.tabDetails.forEach(function (objTab: any, index: any) {
			if (objTab.tab == tab) {
				tabIndex = index;
			}
		})
		return tabIndex;
	}

	public getCompensationMetaData() {
		return this.http.get(this.baseGlobalCompUrl.toString() + '/metadata').toPromise();
	}
}